export class ReferenceAngleInvalidException extends Error {
  constructor(message) {
    super(message ?? 'DRR at angle matching image not found.');
  }
}